import { render, staticRenderFns } from "./basicLogistics.vue?vue&type=template&id=4011fc60&scoped=true"
import script from "./basicLogistics.vue?vue&type=script&lang=js"
export * from "./basicLogistics.vue?vue&type=script&lang=js"
import style0 from "./basicLogistics.vue?vue&type=style&index=0&id=4011fc60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011fc60",
  null
  
)

export default component.exports